// MARK://dhk8/pos/lib/money
// Port of sc-restaurant money.ts — centavos helpers, denominaciones MXN.

const MXN = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' })

export function formatCents(cents: number): string {
  return MXN.format(cents / 100)
}

export function pesosStringToCents(raw: string): number {
  const cleaned = raw.replace(/[^\d.,-]/g, '').replace(/,/g, '.')
  if (cleaned === '' || cleaned === '-' || cleaned === '.') return 0
  const n = Number.parseFloat(cleaned)
  if (!Number.isFinite(n)) return 0
  return Math.round(n * 100)
}

export interface Denomination {
  valueCents: number
  label: string
  kind: 'bill' | 'coin'
}

export const MXN_DENOMINATIONS: readonly Denomination[] = [
  { valueCents: 100_000, label: '$1,000', kind: 'bill' },
  { valueCents: 50_000, label: '$500', kind: 'bill' },
  { valueCents: 20_000, label: '$200', kind: 'bill' },
  { valueCents: 10_000, label: '$100', kind: 'bill' },
  { valueCents: 5_000, label: '$50', kind: 'bill' },
  { valueCents: 2_000, label: '$20', kind: 'bill' },
  { valueCents: 1_000, label: '$10', kind: 'coin' },
  { valueCents: 500, label: '$5', kind: 'coin' },
  { valueCents: 200, label: '$2', kind: 'coin' },
  { valueCents: 100, label: '$1', kind: 'coin' },
  { valueCents: 50, label: '$0.50', kind: 'coin' },
] as const

export type DenominationCounts = Record<number, number>

export function emptyDenominationCounts(): DenominationCounts {
  const out: DenominationCounts = {}
  for (const d of MXN_DENOMINATIONS) out[d.valueCents] = 0
  return out
}

export function totalFromDenominations(counts: DenominationCounts): number {
  let total = 0
  for (const [valueCents, qty] of Object.entries(counts)) {
    if (!qty || qty < 0) continue
    total += Number(valueCents) * qty
  }
  return total
}
